const ALLOCATION_CLASSES = {
  Agressiva: {
    pandhoraEssencial: 0,
    pandhoraLb: 10
  },
  Moderada: {
    pandhoraEssencial: 5,
    pandhoraLb: 5
  },
  Conservadora: {
    pandhoraEssencial: 5,
    pandhoraLb: 0
  },
};

export default ALLOCATION_CLASSES;